import {FAILURE, PENDING, SUCCESS} from '../../constants'
import {useReducer} from 'react'

const ActionTypes = {FAILURE, PENDING, SUCCESS}
const InitialState = {
  data: {},
  errors: null,
  isLoading: false,
}

const Reducer = (state = InitialState, action) => {
  switch (action.type) {
    case PENDING:
      return {
        ...state,
        isLoading: true,
        errors: null,
      }
    case SUCCESS:
      console.log(action)
      return {
        ...state,
        isLoading: false,
        errors: null,
        data: action.payload,
      }
    case FAILURE:
      return {
        ...state,
        errors: action.payload.errors,
        isLoading: false,
      }
    default:
      return state
  }
}

const useReservedForFieldValuesReducer = (state = InitialState) => {
  return useReducer(Reducer, state)
}

export default useReservedForFieldValuesReducer
export {ActionTypes, InitialState, Reducer}
